class DropHint extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.closest('dialog');
    this.form = this.querySelector('form');
    this.fields = this.querySelectorAll('input');
    this.button = this.querySelector('button');
    this.productForm = this.closest('product-form');

    this.subjectTemplate = this.dataset.subject;
    this.bodyTemplate = this.dataset.body;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  getData() {
    this.data = Array.from(this.fields).reduce((data, input) => {
      data[input.name] = encodeURIComponent(input.value);
      return data;
    }, {});
  }

  subject() {
    return this.subjectTemplate
      .replace(
        "__sender_name__", 
        this.data.sender_name
      );
  }

  body() {
    return this.bodyTemplate
      .replace(
        "__sender_name__",
        this.data.sender_name
      )
      .replace(
        "__recipient_name__",
        this.data.recipient_name
      )
      .replace(
        "__product_title__",
        this.productForm.getVariantTitle()
      )
      .replace(
        "__product_url__",
        this.productForm.getVariantURL()
      );
  }

  openMail() {
    this.getData();
    window.location.href = `mailto:${
        this.data.recipient_email
      }?subject=${this.subject()}&body=${this.body()}`;
  }

  onSubmit(ev) {
    ev.preventDefault();

    this.openMail();
    this.dialog.close();
  }
}

customElements.define('drop-hint', DropHint);